import { render, staticRenderFns } from "./CapacidadeMercado.vue?vue&type=template&id=067ae47c"
import script from "./CapacidadeMercado.vue?vue&type=script&lang=js"
export * from "./CapacidadeMercado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports